import { Component } from '@angular/core';

@Component({
    selector : 'my-app',
    templateUrl : 'app.component.html'
})
export class AppComponent {

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/app.component.ts